import { GetterTree } from 'vuex';
import { LlmState } from './types';
import { RootState } from '../../types';

export const getters: GetterTree<LlmState, RootState> = {
  ['getAnswer']: (state) => state.answer,
  ['getIsLoading']: (state) => state.isLoading,
};
